export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-axis/src/identity.js
// module id = 1406
// module chunks = 0